<template>
  <div>
    <hold-key
      v-hammer:press="handlePress"
      v-hammer:pressup="handleRelease"
      v-hammer:pan="panstart"
      v-hammer:panstart="panstart"
      v-hammer:panend="handlePan"
      :name="name"
      :character="character"
      :row="row"
      :hold-hand="holdHand"
      :alt="alt"
      :shift="shift"
    ></hold-key>
  </div>
</template>

<script>
import BaseKey from 'mixins/BaseKey';
import { mapMutations } from 'vuex';
import HoldKey from './HoldKey.vue';

export default {
  name: 'TouchHoldKey',

  data() {
    return {
      isPressed: false
    };
  },

  components: {
    HoldKey
  },

  mixins: [BaseKey],

  props: {
    holdHand: {
      type: String,
      required: true
    }
  },

  methods: {
    ...mapMutations('keyboard', ['pressHoldKey', 'releaseHoldKey']),

    handlePress() {
      this.isPressed = true;
      this.pressHoldKey();
    },

    handleRelease() {
      this.isPressed = false;
      this.releaseHoldKey();
    },

    panstart() {},

    panend() {},

    handlePan() {
      if (this.isPressed) {
        this.releaseHoldKey();
      }
    }
  }
};
</script>
